<template>
    <header class="w-full h-16 sm:h-20 text-xs sm:text-sm bg-white dark:bg-black shadow-md p-3">
        <div class="container mx-auto h-full flex items-center justify-between">

            <select v-model="selectInventory"
                class="h-full px-4 shadow-md rounded-md bg-gray-100 dark:bg-slate-700 mr-16 sm:m-0 text-gray-600 dark:text-gray-200 cursor-pointer"
                :disabled="inventoryList.length == 0">
                <template v-if="inventoryList.length != 0">
                    <option v-for="(inventory, index) in inventoryList" :key="index" :value="inventory.id">{{
                        inventory.persian_name }}</option>
                </template>
            </select>


            <div
                class="h-full flex flex-col items-center justify-center shadow-md bg-gray-100 dark:bg-slate-700 rounded-lg text-gray-600 dark:text-gray-200">
                <div class="w-full flex items-center justify-between px-4 sm:px-5 cursor-pointer">
                    <font-awesome-icon icon="fa-solid fa-wallet" />
                    <p class="px-2">{{ wallet.balance ? changeToPersian(new Intl.NumberFormat().format(wallet.balance)) :
                        changeToPersian(0) }} تومان</p>
                </div>
            </div>

        </div>
    </header>
</template>

<script setup>
//import
import { onMounted, computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { changeToPersian } from '@/composables/changeNumber.js';
import { useRouter } from 'vue-router';
import { toast } from 'vue3-toastify';

// data
const store = useStore();
const selectInventory = ref('');
const router = useRouter();

const isMounted = ref('false');

// stored methods
const isMember = computed(() => {
    return store.getters.getIsAuthenticated;
});

//watchers
watch(selectInventory, (newValue) => {
    store.commit("setInventory", newValue);
    let oldInventory = localStorage.getItem("inventory");
    localStorage.setItem("inventory", newValue);

    if(newValue !== oldInventory && isMounted.value){
        router.push({name: "home"});
    }
}, {flush:'sync'});

// api
function getWalletData() {
    store.dispatch("getWalletDataFromApi");
}
const wallet = computed(() => {
    return store.getters.getWalletData;
})

const inventoryList = computed(() => {
    return store.getters.getInventoryList;
})

onMounted(async () => {
    let inventory = localStorage.getItem("inventory");
    if(!inventoryList.value[0])
        toast.error("لیست انبارها دریافت نشده لطفا صفحه را دوباره بارگذاری کنید.")
    if (inventory && inventoryList.value.some(item => item.id == inventory)){
        selectInventory.value = inventory;
    }
    else
        selectInventory.value = inventoryList.value[0].id;
    if (isMember.value)
        getWalletData();

    isMounted.value = true;
})
</script>